module.exports = __webpack_public_path__ + "img/date-picker.b0dbb684.svg";